import PlayerAvatar from "@/components/PlayerAvatar";
import ScoreRing from "@/components/ScoreRing";

import "./index.scss";

// Testata della scheda giocatore, sotto l'intestazione che ne porta il nome:
// foto, dati essenziali in pillole, voti ad anello e un'azione o uno stato a lato.
// chips: [{id, label, tone}] con tone primary | neutral | good | warning | critical | muted
// scores: [{id, label, value, max}]
export default function PlayerHero({
	player,
	status,
	statusLabel,
	chips = [],
	scores = [],
	aside,
}) {
	return (
		<section className="player-hero" aria-label="Dati del giocatore">
			<PlayerAvatar
				firstName={player?.firstName}
				lastName={player?.lastName}
				imageUrl={player?.imageUrl}
				size="large"
				status={status}
				statusLabel={statusLabel}
			/>
			<div className="player-hero__chips">
				{chips.map((chip) => (
					<span
						key={chip.id}
						className={
							"player-hero__chip player-hero__chip--" + (chip.tone || "neutral")
						}
					>
						{chip.label}
					</span>
				))}
			</div>
			{(!!scores.length || aside) && (
				<div className="player-hero__side">
					{scores.map((score) => (
						<ScoreRing
							key={score.id}
							value={score.value}
							max={score.max}
							label={score.label}
							size="small"
						/>
					))}
					{aside}
				</div>
			)}
		</section>
	);
}
